if (!process.env.REACT_APP_GOOGLE_API_KEY)
  throw new Error(
    `You need to provide REACT_APP_GOOGLE_API_KEY environment variable`
  )
if (!process.env.REACT_APP_API_URL)
  throw new Error(`You need to provide REACT_APP_API_URL environment variable`)
if (!process.env.REACT_APP_STORAGE_URL)
  throw new Error(
    `You need to provide REACT_APP_STORAGE_URL environment variable`
  )
if (!process.env.REACT_APP_INPOST_GEOWIDGET_TOKEN)
  throw new Error(
    `You need to provide REACT_APP_INPOST_GEOWIDGET_TOKEN environment variable`
  )
if (!process.env.REACT_APP_INPOST_GEOWIDGET_SANDBOX)
  throw new Error(
    `You need to provide REACT_APP_INPOST_GEOWIDGET_SANDBOX environment variable`
  )
export const InpostGeowidget = {
  token: process.env.REACT_APP_INPOST_GEOWIDGET_TOKEN,
  sandbox: process.env.REACT_APP_INPOST_GEOWIDGET_SANDBOX === 'true',
}

export const GoogleApiKey = process.env.REACT_APP_GOOGLE_API_KEY
export const ApiUrl = process.env.REACT_APP_API_URL
export const StorageUrl = process.env.REACT_APP_STORAGE_URL
